import { useStore } from 'effector-react'
import * as React from 'react'
import { $giftCategory, getGiftCategory, giftCategoryMounted } from './model'

export const useEditGiftCategory = () => {
  const giftCategory = useStore($giftCategory)
  const loading = useStore(getGiftCategory.pending)

  React.useEffect(() => {
    giftCategoryMounted()
  }, [])

  return { giftCategory, loading }
}
